import DynamicForm, { DynamicFormProps } from "./DynamicForm";

export { DynamicForm, DynamicFormProps };

export default DynamicForm;
